class PdpDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('[data-pdp-drawer-overlay]');
    this.titleEl = this.querySelector('[data-pdp-drawer-title]');
    this.bodyEl = this.querySelector('[data-pdp-drawer-body]');
    this.closeBtn = this.querySelector('[data-pdp-drawer-close]');
  }

  connectedCallback() {
    this.closeBtn?.addEventListener('click', () => this.close());

    this.overlay?.addEventListener('click', (e) => {
      if (e.target === this.overlay) this.close();
    });

    document.addEventListener('click', (e) => {
      const trigger = e.target.closest('[data-pdp-drawer-open]');
      if (!trigger) return;

      e.preventDefault();
      const contentKey = trigger.getAttribute('data-pdp-drawer-open');
      const title = trigger.getAttribute('data-pdp-drawer-title') || '';
      this.open(contentKey, title);
    });
  }

  open(contentKey, title) {
    const template = this.querySelector(
      `template[data-drawer-content="${contentKey}"]`
    );
    if (!template) return;

    this.titleEl.textContent = title;
    this.bodyEl.innerHTML = '';
    this.bodyEl.appendChild(template.content.cloneNode(true));

    this.overlay.style.display = 'flex';
    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.overlay.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
  }
}

if (!customElements.get('pdp-drawer')) {
  customElements.define('pdp-drawer', PdpDrawer);
}
